import React, { ReactElement } from "react";
import styles from "./sectionHeaderComponent.module.scss";
import { eventBus, getCmsIcon } from "@kunduz/utility-common";
import { Button } from "@kunduz/ui-atoms";
import Link from "next/link";
import classNames from "classnames";
import { CommonComponentProps } from "../../config";
import { useRouter } from "next/router";

export const SectionHeaderComponent = (
  props: SectionHeaderComponentProps,
): ReactElement => {
  const {
    badgeIcon,
    badgeTitle,
    buttons,
    description,
    title,
    badgeTitleTheme,
    options: {
      alignmentDesktop,
      alignmentMobile,
      alignmentTablet,
      sizeDesktop,
      sizeMobile,
      sizeTablet,
    },
  } = props;

  const router = useRouter();

  const gradientToUse = {
    blue_gradient: styles.blueG,
    green_gradient: styles.greenG,
  };

  const BadgeIcon = getCmsIcon(badgeIcon);

  const onCtaClicked = (e: React.MouseEvent, url: string) => {
    if (url.startsWith("event://")) {
      e.preventDefault();
      e.stopPropagation();

      const [eventName, id] = url.split("/").slice(-2);

      eventBus.emit(eventName, id);
    }
  };

  return (
    <div
      className={classNames(
        styles.container,
        styles[`${sizeMobile}Mobile`],
        styles[`${sizeTablet}Tablet`],
        styles[`${sizeDesktop}Desktop`],
        styles[`${alignmentDesktop}AlignmentDesktop`],
        styles[`${alignmentMobile}AlignmentMobile`],
        styles[`${alignmentTablet}AlignmentTablet`],
      )}
    >
      <div className={styles.contentContainer}>
        {(badgeIcon || badgeTitle) && (
          <div className={styles.badgeContainer}>
            {badgeIcon && <BadgeIcon />}
            {badgeTitle && (
              <span className={classNames(gradientToUse[badgeTitleTheme])}>
                {badgeTitle}
              </span>
            )}
          </div>
        )}
        {title && <div className={styles.title}>{title}</div>}
        {description && (
          <div
            className={styles.description}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
        {buttons?.length > 0 && (
          <div className={styles.buttonsContainer}>
            {buttons.map((button, i) => (
              <Button
                color="tutorGreen"
                as={Link}
                href={`${router.asPath}/${button.url}`}
                key={i}
                onClick={(e) => onCtaClicked(e, button.url)}
                className={classNames(styles.button, {
                  [styles.primary]: button.type === "primary",
                  [styles.secondary]: button.type === "secondary",
                })}
                shallow={button?.url?.includes("modal")}
                scroll={!button?.url?.includes("modal")}
              >
                {button.image && <img src={button.image} />}
                {button.label}
              </Button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export interface SectionHeaderComponentProps extends CommonComponentProps {
  badgeIcon: string;
  badgeTitle: string;
  buttons: {
    image: string;
    label: string;
    target: string;
    type: string;
    url: string;
  }[];
  description: string;
  title: string;
  badgeTitleTheme: string;
}
